window.Drupal.behaviors.loginMeals = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", () => {
      // Boton volver
      document.querySelector('#login-user-back-btn, #recovery-user-back-btn').addEventListener('click', function () {
        window.history.back()
      });

      // Agrega clases a los labels
      const labels = document.querySelectorAll('#user-login-form label')

      labels.forEach(label => {
        label.classList.add('login-user-form--label')
        label.classList.add('m-top')
      })

      // Agrega clases al boton
      const buttonWrapper = document.querySelector('#user-login-form #edit-actions')
      buttonWrapper.classList.add('login-user-form-btn--wrapper')

      const button = document.querySelector('#user-login-form #edit-submit-send')
      button.classList.add('login-user-form-btn')
      button.classList.add('btn-disabled')

      // Duplica el error de Email a Password
      const selectInputName = document.querySelector('#user-login-form #edit-name')

      const haveError = selectInputName.classList.contains('error')

      if (haveError) {
        selectInputPass.classList.add('error')
        selectInputPass.classList.add('is-invalid')

        const errorMessage = document.querySelector('#user-login-form .form-item--error-message')
        if (errorMessage) {
          const clonedErrorMessage = errorMessage.cloneNode(true)
          selectInputPass.parentNode.insertBefore(clonedErrorMessage, selectInputPass.nextSibling)
        }
      }

      /**
       * Crea un contenedor div con una clase
       * Agrega el input de contraseña dentro
       * Agrega un span bajo el input
       */
      const selectInputPass = document.querySelector('#user-login-form #edit-pass')
      const wrapperDiv = document.createElement('div')
      wrapperDiv.classList.add('login-user-form--input-wrapper')

      selectInputPass.insertAdjacentElement('beforebegin', wrapperDiv)
      wrapperDiv.appendChild(selectInputPass)

      const insertSpan = `
      <span id="login-password-icon" class="login-user-form-input--icon eye eye-hide" >
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.6315 12.7082L22.6965 13.063L23.6315 12.7082ZM23.6315 13.8955L24.5664 14.2504L23.6315 13.8955ZM4.30303 13.063C5.71135 9.35285 9.29917 6.71851 13.4998 6.71851V4.71851C8.44134 4.71851 4.12661 7.89204 2.4332 12.3533L4.30303 13.063ZM13.4998 6.71851C17.7004 6.71851 21.2882 9.35285 22.6965 13.063L24.5664 12.3533C22.873 7.89205 18.5582 4.71851 13.4998 4.71851V6.71851ZM22.6965 13.5407C21.2882 17.2508 17.7004 19.8852 13.4998 19.8852V21.8852C18.5582 21.8852 22.873 18.7116 24.5664 14.2504L22.6965 13.5407ZM13.4998 19.8852C9.29917 19.8852 5.71135 17.2508 4.30303 13.5407L2.4332 14.2504C4.12661 18.7116 8.44134 21.8852 13.4998 21.8852V19.8852ZM22.6965 13.063C22.7549 13.2167 22.7549 13.387 22.6965 13.5407L24.5664 14.2504C24.7983 13.6395 24.7983 12.9642 24.5664 12.3533L22.6965 13.063ZM2.4332 12.3533C2.2013 12.9642 2.2013 13.6395 2.4332 14.2504L4.30303 13.5407C4.24469 13.387 4.24469 13.2167 4.30303 13.063L2.4332 12.3533Z" fill="#808080"/>
          <circle cx="13.5" cy="13.3018" r="3.25" stroke="#808080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>`

      wrapperDiv.insertAdjacentHTML('beforeend', insertSpan)

      // Agrega clases de error
      setInterval(() => {
        const errorMessages = document.querySelectorAll('#user-login-form #pass-error-message')
        const inputsError = document.querySelectorAll('.login-user-form-input')

        if (errorMessages.length > 0) {
          inputsError.forEach(input => {
            input.classList.add('input_error')
          })
        }

      }, 500)
    })
  }
}